import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "components/Button/Button";
import { Loading } from "components/Loading/loading";
import { ModalForm } from "components/ModalForm/ModalForm";
import { Textbox } from "components/Textbox/Textbox";
import { useEffect, useState } from "react";
import { ICON_TYPE } from "utils/constants";

// import { postPeriodInitDetailBulkAddApi } from "./api";

import { PriceInput } from "components/PriceInput/PriceInput";
import { trans } from "utils/helpers";
import { SellectableWarehouseItem } from "../WarehouseIO/components/SellectableWarehouseItem/SellectableWarehouseItem";
import { postBatchAddApi, putBatchEditApi } from "./api";

interface Prop {
  resetForm?: boolean;
  onHide: () => void;
  PeriodInitObj?: any;
  haveDetail?: any;
  saveWarehouseInPeriodInit?: any;
  reload: () => void;
  detailMode?: "edit" | "create";
  editSelectedList?: any;
}

export const PeriodInitDetailBulkAdd = ({
  reload,
  onHide,
  saveWarehouseInPeriodInit,
  haveDetail,
  PeriodInitObj,
  detailMode,
}: Prop) => {
  const [resetForm, setResetForm] = useState(false);
  const [userChanges, setUserChanges] = useState<any>({});
  const [loading, setLoading] = useState<any>(true);
  const [all, setAll] = useState<any>();
  const [fixedPrice, setFixedPrice] = useState<any>(true);
  const [PriceValue, setPriceValue] = useState<any>(false);
  const [showTree, setShowTree] = useState<any>();
    const [itemSearch, setItemSearch] = useState<any>({
      From:'',
      To:''
    }); 
  const [treeType, setTreeType] = useState<any>();
  const [werhoseList, setWerhoseList] = useState<any>([]);
  const [selectedWerhose, setSelectedWerhose] = useState<any>([]);
  const [itemCodeData, setItemCodeData] = useState<any>({});
  const [needToCall, setNeedToCall] = useState<any>(true);
  const [unitPriceValue, setUnitPriceValue] = useState(0);
  const [hasPeriodInitUnitOnly, setHasPeriodInitUnitOnly] = useState<any>(true);
  const [warehouseData, setWarehouseData] = useState<any>({
    WarehouseId:
      JSON.parse(localStorage.getItem("DefaultInventory") as any)?.Id ?? null,
  });

  const itemCodeHandeler = (obj) => {
    setLoading(false);


    setItemCodeData({
      ...itemCodeData,

      [treeType]: obj.ItemCode,
    });
    setShowTree(false);
    setLoading(true);
  };
  const handleBeforeUnload = (event) => {
    event.preventDefault();
    event.returnValue = "";
  };


  const submit = async (event) => {
    event.preventDefault();
    const data = {
  
      From: itemCodeData.From,
      To: itemCodeData.To,
      QtyIn1: event.target.QtyIn1?.value ? +event.target.QtyIn1?.value?.replaceAll(',','') : 0,
      ItemValueIn: event.target.ItemValueIn?.value
        ? +event.target.ItemValueIn?.value?.replaceAll(',','') 
        : 0,
    };
    try {
      if(detailMode=='create'){
    await postBatchAddApi({...data,WarehouseId: warehouseData.WarehouseId,
      WarehouseDetailId: warehouseData.WarehouseDetailId
        ? warehouseData.WarehouseDetailId
        : null,});
      }else{
    await putBatchEditApi(data);

      }
    
        reload();
      } catch (error) {}

  };

  function addOption(e) {
    setTreeType(e);
    setShowTree(true);
  }

  useEffect(() => {
    if (resetForm) {
      setUserChanges({});
    }
  }, [resetForm]);


  return (
    <>
      {showTree && (
        <ModalForm
          mode={detailMode}
          title="ItemTree"
          onHide={() => setShowTree(false)}
          show={showTree}
        >
          <SellectableWarehouseItem
            onHide={() => {
              setShowTree(false);
            }}
            fetchItem={true}
            itemCodeHandeler={itemCodeHandeler}
            warehouseId={warehouseData?.WarehouseId}
            warehouseDetailId={warehouseData?.WarehouseDetailId}
            forItemInput={true}
             searchString={itemSearch[treeType]}
          />
        </ModalForm>
      )}

      {loading ? (
        <>
          <form className=" " onSubmit={submit}>
            <div className="">
              <div className="card-body">
                <div className="row">
                  {/* <div className="col-12 col-md-3 ">
                    <WarehouseDictionaryWithAccess
                      name="Warehouse"
                      label="Warehouse"
                      resetForm={resetForm}
                      value={
                        JSON.parse(localStorage.getItem("DefaultInventory") as any)?.Id
                      }
                      onChange={(e, obj) => {
                        setWarehouseData({
                          ...warehouseData,
                          WarehouseDetailsCount:
                            obj?.Name?.WarehouseDetailsCount,
                        });
                      }}
                      mode={"view"}
                      required={true}
                    />
                  </div>
                    {warehouseData?.WarehouseDetailsCount > 0 && (
                  <div className="col-12 col-md-3">
                      <div className="">
                        <DictionarySelectBox
                          required
                          name="WarehouseDetail"
                          label="WarehouseDetail"
                          params={{ warehouseId: warehouseData?.WarehouseId }}
                          onChange={(e, obj) => {
                            setWarehouseData((prev) => {
                              return {
                                ...prev,
                                WarehouseDetailId: e,
                                WarehouseDetail: obj?.Name,
                              };
                            });
                          }}
                          baseUrl={INVENTORYANDSALES_URL}
                          endPoint={
                            ENDPOINTSINVENTORYANDSALES.Inventory
                              .BaseInformationApi.WarehouseDetail.dictionary
                          }
                          resetForm={resetForm}
                          mode={detailMode != "create" ? "view" : "create"}
                        />
                      </div>
                  </div>
                    )} */}

                  <>
                    <div
                      className="col-md-3 col-sm-12 "
                      style={{
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "row",
                      }}
                    >
                      <Textbox
                        required
                        Change={(e) => {
                          setUserChanges({ ...userChanges, ...e });
                        }}
                        onChange={(e) => {
                          setItemCodeData({
                            ...itemCodeData,
                            From: e.target.value,
                          });
                    setItemSearch({...itemSearch,From:e.target.value});
                        }}
                        textboxName={"from"}
                        placeholder={trans('itemCode')}
                        textboxType="text"
                        resetForm={resetForm}
                        labelText={"from"}
                        mode={detailMode}
                        defaultValue={itemCodeData?.From}
                      />
                      <div style={{ marginTop: "4px", width: "10%" }}>
                        <Button
                          Icon={true}
                          value={
                            <button
                              onClick={(e) => addOption("From")}
                              type="button"
                              className="checkButton"
                            >
                              {" "}
                              <FontAwesomeIcon
                                icon={[ICON_TYPE, "diagram-project"]}
                                size="1x"
                              />
                            </button>
                          }
                          btnType="primary"
                          onClick={(e) => addOption("From")}
                        />
                      </div>
                    </div>
                    <div
                      className="col-md-3 col-sm-12"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "row",
                      }}
                    >
                      <Textbox
                        required
                        Change={(e) => {
                          setUserChanges({ ...userChanges, ...e });
                        }}
                        onChange={(e) => {
                            setItemCodeData({
                            ...itemCodeData,
                            To: e.target.value,
                          });
                                             setItemSearch({...itemSearch,To:e.target.value});
                        }
                      }
                        textboxName={"To"}
                        textboxType="text"
                        resetForm={resetForm}
                        labelText={"To"}
                        placeholder={trans('itemCode')}
                        mode={detailMode}
                        defaultValue={itemCodeData?.To}
                      />
                      <div style={{ marginTop: "4px", width: "10%" }}>
                        <Button
                          Icon={true}
                          value={
                            <button
                              onClick={(e) => addOption("To")}
                              type="button"
                              className="checkButton"
                            >
                              {" "}
                              <FontAwesomeIcon
                                icon={[ICON_TYPE, "diagram-project"]}
                                size="1x"
                              />
                            </button>
                          }
                          btnType="primary"
                          onClick={(e) => addOption("To")}
                        />
                      </div>
                    </div>
                  </>

                  <div className="col-12 col-md-3">
                    <Textbox
                      required
                      textboxName={"QtyIn1"}
                      textboxType="text"
                      resetForm={resetForm}
                      labelText={"QtyIn1"}
                      mode={detailMode}
                    />
                 
                  </div>
                  <div className="col-12 col-md-3">
                    {/* <Textbox
                      required
                      textboxName={"ItemValueIn"}
                      textboxType="text"
                      resetForm={resetForm}
                      labelText={"ItemValueIn"}
                      mode={detailMode}
                      useGroupingPrice
                    /> */}
                    <PriceInput
                       required
                      name={"ItemValueIn"}
                      resetForm={resetForm}
                      label={"ItemValueIn"}
                      mode={detailMode}
                    />
                  </div>
                </div>
              </div>
            </div>

 
              <div className="col-lg-12 mt-1 btns_form">
                <Button value="Save" btnType="submit" />
                <Button btnType="cancel" value="Cancel" onClick={onHide} />
              </div>
         
          </form>
        </>
      ) : (
        <Loading />
      )}
    </>
  );
};
